export default __webpack_public_path__ + "static/media/harbor1.8fc4c51a.jpg";